const backgrounds: Record<number, string> = {
  2: '/assets/images/background/phase-2-crystal-grotto.webp',
  3: '/assets/images/background/phase-3-autumn-sanctuary.webp',
  4: '/assets/images/background/phase-4-storm-temple.webp',
  5: '/assets/images/background/phase-5-celestial-sanctuary.webp',
};

/** The original forest stays underneath, including while an image is loading. */
export class PhaseBackground {
  private phase = 0;
  private readonly images = new Map<number, Promise<HTMLImageElement | null>>();
  private readonly layer = document.createElement('div');

  public constructor() {
    this.layer.className = 'world-background';
    this.layer.setAttribute('aria-hidden', 'true');
    document.body.prepend(this.layer);
    this.update(1);
  }

  public update(phase: number): void {
    if (phase === this.phase) return;
    this.phase = phase;
    if (phase === 1) this.show(null);
    else void this.load(phase).then((image) => {
      // A restart or another phase can arrive before decoding finishes.
      if (this.phase === phase && image) this.show(image);
    });
    void this.load(phase + 1);
  }

  private show(active: HTMLImageElement | null): void {
    for (const image of this.layer.children) {
      image.classList.toggle('world-background__image--active', image === active);
    }
  }

  private load(phase: number): Promise<HTMLImageElement | null> {
    const path = backgrounds[phase];
    if (!path) return Promise.resolve(null);
    const cached = this.images.get(phase);
    if (cached) return cached;
    const image = new Image();
    image.alt = '';
    image.className = 'world-background__image';
    image.dataset.phase = String(phase);
    image.decoding = 'async';
    image.src = path;
    const ready = image.decode().then(() => {
      this.layer.append(image);
      // Establish the transparent starting style before revealing the image.
      void image.offsetWidth;
      return image;
    }).catch(() => {
      this.images.delete(phase);
      return null;
    });
    this.images.set(phase, ready);
    return ready;
  }
}
